import { Pill } from "@/components/ui";
import { t } from "@/i18n";
import { fmtInt } from "@/lib/utils";

export interface KargoSirketiOge {
  company: string;
  total: number;
  critical: number;
  warning: number;
}

/**
 * Kargo şirketi dağılımı — yolda bekleyen siparişler şirket bazında; en fazla
 * 4 şirket. Kart vurgu çizgisi en kötü duruma göre (kritik kırmızı, uyarı
 * sarı, hepsi süresinde yeşil).
 */
export function KargoSirketiGrid({ companies, onOpen }: { companies: KargoSirketiOge[]; onOpen?: () => void }) {
  const top = companies.slice(0, 4);

  if (top.length === 0) {
    return <p className="text-sm text-muted">{t("ozet.kargo_sirketi.bos")}</p>;
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4" data-testid="kargo-sirketi-grid">
      {top.map((c) => {
        const tone = c.critical > 0 ? "kpi-bad" : c.warning > 0 ? "kpi-warn" : "kpi-ok";
        const clickable = Boolean(onOpen);
        return (
          <div
            key={c.company}
            className={`kpi ${tone} ${clickable ? "kpi-clickable" : ""}`}
            onClick={onOpen}
            role={clickable ? "button" : undefined}
            tabIndex={clickable ? 0 : undefined}
            onKeyDown={
              clickable
                ? (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      onOpen?.();
                    }
                  }
                : undefined
            }
          >
            <p className="kpi-lbl">{c.company}</p>
            <p className="kpi-val mt-2">
              {fmtInt(c.total)} <span className="text-sm font-medium text-muted">{t("ozet.kargo_sirketi.yolda")}</span>
            </p>
            <div className="mt-2 flex flex-wrap gap-1.5">
              {c.critical > 0 && <Pill tone="bad">{fmtInt(c.critical)} {t("ozet.kargo_sirketi.kritik")}</Pill>}
              {c.warning > 0 && <Pill tone="warn">{fmtInt(c.warning)} {t("ozet.kargo_sirketi.uyari")}</Pill>}
              {c.critical === 0 && c.warning === 0 && <Pill tone="ok">{t("ozet.kargo_sirketi.hepsi_suresinde")}</Pill>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
